



























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  CombinedClaimReceiptStatus,
  CombinedClaimReceiptStatusMap,
  HsabExpenseCategory,
  hsabExpenseOriginatorTypeMap,
  HsabExpenseResponse
} from "@/shared/types";
import moment from "moment";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";
import { formatCurrency } from "@/shared/currency.js";
import { useUserStore } from "@/shared/store/user";
import { useFamilyStore } from "@/employee/store/family";

@Component({
  components: {
    HsabExpenseReimbursementStatusPill
  }
})
export default class HsbExpenseCardRowExpenseDetail extends Vue {
  formatCurrency = formatCurrency;
  hsabExpenseOriginatorTypeMap = hsabExpenseOriginatorTypeMap;

  userStore = useUserStore();
  familyStore = useFamilyStore();

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  get formattedDateOfService () {
    return moment(this.expense.dateOfService).format("MMM DD, YYYY");
  }

  get formattedOriginator () {
    if (this.expense.originator) {
      return this.hsabExpenseOriginatorTypeMap[this.expense.originator];
    }
    return "Unknown";
  }

  get status (): CombinedClaimReceiptStatus {
    return this.expense.reimbursement ?
        this.expense.reimbursement.claimReceiptStatus :
        CombinedClaimReceiptStatus.None;
  }

  get statusDisplayText () {
    return CombinedClaimReceiptStatusMap[this.status];
  }

  get showCategory () {
    return this.expense.expenseCategory !== undefined
        && this.expense.expenseCategory !== null
        && this.expense.expenseCategory !== HsabExpenseCategory.Unknown;
  }

  get showExpenseType () {
    return this.expense.expenseType !== undefined
        && this.expense.expenseType !== null
        && this.expense.expenseType !== "";
  }

  get showExpenseSubType () {
    return this.expense.expenseSubType !== undefined
        && this.expense.expenseSubType !== null
        && this.expense.expenseSubType !== "";
  }

  get SubTypeDisplay () {
    if (this.expense.expenseSubTypeDisplayName !== undefined
        && this.expense.expenseSubTypeDisplayName !== null
        && this.expense.expenseSubTypeDisplayName !== "") {
      return this.expense.expenseSubTypeDisplayName;
    }
    if (this.expense.expenseSubType !== undefined
        && this.expense.expenseSubType !== null
        && this.expense.expenseSubType !== "") {
      return this.expense.expenseSubType;
    }

    return "";
  }

  get recipientDisplay () {
    if (this.expense.importedRecipients && this.expense.importedRecipients.length > 0) {
      return this.expense.importedRecipients.map(t => {
        return t.firstName + " " + t.lastName;
      }).join("\n");
    } else if (this.expense.recipientExternalId) {
      const recipient = this.familyStore.getFamilyMemberByExternalId(this.expense.recipientExternalId);
      if (recipient) {
        return recipient.firstName + " " + recipient.lastName;
      }
      return "";
    }
    else {
      return this.userStore.displayName;
    }
  }
}
